import * as moment from 'moment';
import {Utils} from "./Utils";


export class DateEncoding {

    public static ALL_DAY= 562949953421311;

    retrieveDates (encodedInterval: number): Date[] {
      const res: Date[] = [];

        let interval: number[] = this.nextInterval(encodedInterval, -1);
        while (interval.length === 2) {
            res.push( this.bitToDate( interval[0] ));
            res.push( this.bitToDate( interval[1] ));
            interval = this.nextInterval(encodedInterval, interval[1]);
        }
        return res;
    }

    /*

     public List<Date> retrieveDates(long encodedInterval){
     List<Date> res = new ArrayList<Date>();
     int interval[] = nextInterval(encodedInterval,-1);
     while (interval.length==2){
     res.add(bitToDate(interval[0]));
     res.add(bitToDate(interval[1]));
     interval = nextInterval(encodedInterval,interval[1]);
     }

     return res;
     }
     */

  /**
   18:30-03:00 is overnight
   22:00-24:30 is overnight
   22:00-24:00 is not
   14:00-15:00 is considered as 1 hour shift not a 25 hours shift.

   18:30-00:00 is NOT overnight
   22:00-00:01 is overnight
   */
   isOvernight(start: {h: number, m: number}, end: {h: number, m: number}): boolean {
    if (start.h > end.h) {
      if (end.h===0 && end.m===0){
        return false;
      }
      return true;
    }
    // We are supporting the 24 format to simplify the reading...
    // 19:30 - 24:30 is legal for us and means 7:30 pm to 0:30 am
    if ((end.h === 24) && (end.m > 0)) {
      return true;
    }
    return false;
  }

  isOvernightWithDate(start: Date, end:Date):boolean{
     const ms = moment(start);
     const me = moment(end);
     return this.isOvernight({h:ms.hour(),m:ms.minute()},{h:me.hour(),m:me.minute()});
  }


  encode(startDate: Date, endDate: Date): number {
      const startBit = this.dateToBit(startDate);

      let stopBit = this.dateToBit(endDate);
      if (this.isMidnight(endDate)){
        stopBit = 48; // 00:00 should be seen as 24:00 or 23:59 aka bit 48.
      }
         if ( stopBit > startBit ) {
            // Create array of 1 and 0
            // 48 bits => 24 hours * 2 (for 30 min)
            let binary = '';
            for (let idx = 0; idx <= 48; idx++) {
                if (( idx >= startBit ) && ( idx <= stopBit ) ) {
                    binary = '1' + binary;
                }else {
                    binary = '0' + binary;
                }
            }
           const res = parseInt(binary, 2);
            return res;
         }
         return -1;
    }


  encodeWithOvernightCheckOnDates(startDate: Date, endDate: Date): { interval:number, intervalOverNight: number} {
    const st = moment(startDate);
    const ed = moment(endDate);
    return this.encodeWithOvernightCheck({h:st.hour(),m:st.minute()},{h:ed.hour(),m:ed.minute()});
  }

    encodeWithOvernightCheck(startTime:{h:number,m:number}, endTime:{h:number, m: number}): { interval:number, intervalOverNight: number} {
      let res = {interval: 0, intervalOverNight: 0};
      const overnight = this.isOvernight(startTime, endTime);
      if (overnight) {
        let startDt = moment().startOf('day').hour(startTime.h).minute(startTime.m).toDate();
        let endDt = moment().endOf('day').toDate();
        res.interval = this.encode(startDt, endDt);
        startDt = moment().startOf('day').toDate();
        // The 24:30 should be written as 00:30 am
        if (endTime.h === 24) {
          endTime.h = 0;
        }
        endDt = moment().startOf('day').hour(endTime.h).minute(endTime.m).toDate();
        res.intervalOverNight = this.encode(startDt, endDt);
      }else {
        res.intervalOverNight = 0;
        const startDt = moment().startOf('day').hour(startTime.h).minute(startTime.m).toDate();

        let endDt = moment().startOf('day').hour(endTime.h).minute(endTime.m).toDate();
        if (endTime.h === 24) {
          // It CANT be 24:30 -> Would be overnight
          // 24:00 is rewritten 23:59:59
          endDt = moment().endOf('day').toDate();
        }
        res.interval = this.encode(startDt, endDt);
      }
      return res;
    }


    minBitOf(encoded: number): number{
      if (encoded==0){
        return -1;
      }else if (encoded === DateEncoding.ALL_DAY){
        return 0;
      }else{
        let s = encoded.toString(2);
//        console.log('Min Working on: ' + s);
        let tmp = 0;
        for (let idx=s.length-1; idx>=0; idx--){
            if (s[idx]==='1'){
              return tmp;
            }
            tmp++;
        }
        return -2;
      }
    }

    maxBitOf(encoded: number): number{
      if (encoded==0){
        return -1;
      }else if (encoded === DateEncoding.ALL_DAY){
        return 48;
      }else{
        let s = encoded.toString(2);
  //      console.log('Max Working on: ' + s);
        for (let idx=0; idx<s.length; idx++){
          if (s[idx]==='1'){
            return s.length - idx - 1;
          }
        }
        return -2;
      }
    }

    isBitSet(encoded:number, bit: number) : boolean {
     if (bit<0) return false;
     if (bit>48) return false;
      let s = encoded.toString(2);
      let tmp = 0;
      for (let idx=s.length-1; idx>=0; idx--){
        if (tmp===bit){
          if (s[idx] === '1'){
            return true;
          }
        }
        tmp++;
      }
      return false;
    }

    isBitNotSet(encoded:number, bit: number) : boolean {
      if (bit<0) return false;
      if (bit>48) return false;
      let s = encoded.toString(2);
      let tmp = 0;
      for (let idx=s.length-1; idx>=0; idx--){
        if (tmp===bit){
          if (s[idx] === '0'){
            return true;
          }
        }
        tmp++;
      }
      return false;
    }


  bitToDate( bit: number): Date {
        let min = bit % 2;
        let hour = bit / 2 ;
        // cal.set(Calendar.HOUR_OF_DAY,hour);
        if ( min === 1 ) {
            min = 30;
        }else {
            min = 0;
        }
        if ( bit === 48 ) {
            // Midnight case...
            hour = 23;
            min = 59;
        }
        return moment().hour(hour).minute(min).toDate();
    }

  isMidnightHourMin(end: {h: number, m: number}): boolean {
    if ((end.h === 0) && (end.m === 0)) {
      return true;
    }
    return false;
  }

    isMidnight( date:Date): boolean{
      if (Utils.isNullOrUndefined(date)) {
        return false;
      }
      const mmnt: moment.Moment =  moment(date);
      return this.isMidnightHourMin({h:mmnt.hour(),m:mmnt.minute()});
      /*
      const min: number = mmnt.minute();
      const hour: number = mmnt.hour();
      if (hour === 0){
        if (min === 0){
          return true;
        }
      }
      return false;
      */
    }

     dateToBit ( date: Date ): number {
        let res: number = -1;
        if (!date) {
            return res;
        }
       const mmnt: moment.Moment =  moment(date);
        const min: number = mmnt.minute();
       const hour: number = mmnt.hour();

        res = hour * 2;

        if (min > 0 && min <= 30) {
            res ++;
        }
        if (min > 30) {
            res += 2;
        }
        return res;
     }

    nextInterval(encoded: number, afterThisBit: number): number[] {
        let res: number[] = [2];
        let s = encoded.toString(2);
       // console.log('Working on: ' + s + ' afterThisbit ' + afterThisBit);
        if ( s.length < afterThisBit ) {
            return [];
        }

        let bit = afterThisBit + 1;

        if (afterThisBit < 0) {
            afterThisBit = s.length;
            bit = 0;
        } else {
            afterThisBit = s.length - (afterThisBit + 1);
        }

        // System.out.println("start: " + s);
        let foundSet  = false;
        let foundUnset = false;
        for (let idx = afterThisBit - 1; idx >= 0; idx--) {
//        for (int idx = s.length()-1;idx>=0;idx--){
            if (foundSet && s.charAt(idx) === '0' ) {
                res[1] = bit - 1 ;
                foundUnset = true;
                break;
            }
            if (!foundSet && s.charAt(idx) === '1' ) {
                foundSet = true;
                res[0] = bit;
            }
           // console.log('foundSet: ' + foundSet + ' foundUnset: ' + foundUnset + ' bit: ' + bit  + ' charAt(' + idx + '): ' + s.charAt(idx) + ' res[0,1]: ' + res[0] + ', ' + res[1]);
            bit++;
        }

        if (!foundSet) {
            res = [];
        //            bit = 0;
        //            bit = -1;
        }else {
            if (!foundUnset) {
                res[1] = bit - 1;
            }
        }
        // console.log('Final foundSet: ' + foundSet + ' foundUnset: ' + foundUnset + ' bit: ' + bit  + ' charAt(' + idx + '): ' + s.charAt(idx) + ' res[0,1]: ' + res[0] + ', ' + res[1]);
        return res;

    }

}

